export const rolePermissions = {
  Admin: ["menu", "dashboard", "reports", "tables", "live-order", "order-history", "order-cancelled", "notification", "home",
    "menu-status","table","bills","user-alter","qr-code","table-setting", "tax-setting", "restaurant-setting", "device-settings",
    "reservation","waiterRequest","staff","placeOrder","KOT",
    "takeaway-orders","takeaway-create","takeaway-kot","takeaway-history","takeaway-cancelled",
    "takeaway-bills","takeaway-settings", "shift-closing", "billing-audit", "billing-void", "billing-refund", "billing-payment-correction", "table-operations", "security-settings"
  ],
  Manager: ["menu", "dashboard", "reports", "tables", "live-order", "order-history", "order-cancelled", "notification", "home",
    "menu-status","table","bills","user-alter","qr-code","table-setting", "tax-setting", "restaurant-setting", "device-settings",
    "reservation","waiterRequest","staff","KOT",
    "takeaway-orders","takeaway-create","takeaway-kot","takeaway-history","takeaway-cancelled","takeaway-bills",
    "shift-closing", "billing-audit", "billing-void", "billing-refund", "billing-payment-correction", "table-operations", "security-settings"
  ],
  Staff: ["home", "tables","table", "bills","KOT","live-order", "order-history", "order-cancelled", "notification",
    "takeaway-orders","takeaway-create","takeaway-kot","takeaway-history","takeaway-bills", "billing-audit", "billing-payment-correction", "reservation","waiterRequest"
  ],
  Cashier: ["home", "placeOrder", "tables", "table", "bills", "KOT", "live-order",
    "order-history", "notification", "takeaway-orders", "takeaway-create", "takeaway-kot", "takeaway-history",
    "takeaway-bills", "shift-closing", "billing-audit", "billing-payment-correction",  "reservation","waiterRequest"
  ],
};

const takeawayFeatures = ["takeaway-orders","bills", "takeaway-create", "takeaway-kot", "takeaway-history",
  "takeaway-cancelled", "takeaway-bills", "takeaway-settings"];
const advancedBillingFeatures = ["shift-closing", "billing-audit", "billing-void", "billing-refund", "billing-payment-correction", "table-operations", "security-settings"];

export const packagePermissions = {
  "Catalog Plan": ["menu","home"],
  "Counter Express": ["home", "dashboard", "reports", "placeOrder", "bills","menu-categories","menu-status","menu",
     "staff", "user-alter", "tax-setting", "restaurant-setting", "device-settings", ...advancedBillingFeatures],
  "Dine-In Classic": ["menu", "dashboard", "reports", "tables", "live-order", "order-history", "order-cancelled", "notification", "home",
    "menu-status","table","bills","table-setting", "tax-setting", "restaurant-setting", "device-settings",
    "reservation","staff","KOT","user-alter","qr-code", ...takeawayFeatures, ...advancedBillingFeatures
  ],
  "Smart Ultimate":["menu", "dashboard", "reports", "tables", "live-order", "order-history", "order-cancelled", "notification", "home",
    "menu-status","table","bills","qr-code","table-setting", "tax-setting", "restaurant-setting", "device-settings",
    "reservation","waiterRequest","staff","KOT", "user-alter", ...takeawayFeatures, ...advancedBillingFeatures
  ],
  "Takeaway": ["home", "dashboard", "reports", "menu", "menu-categories", "menu-status", "notification",
    "staff", "user-alter", "tax-setting", "restaurant-setting", "device-settings", ...takeawayFeatures, ...advancedBillingFeatures
  ]
};

export const hasPermission = (role, plan, feature) => {
  return (
    rolePermissions[role]?.includes(feature) &&
    packagePermissions[plan]?.includes(feature)
  );
};
